export default function lerp(start: number, end: number, progress: number): number {
  return start * (1 - progress) + end * progress;
}
